<template lang="html">
  <v-layout row wrap >
  <!--   <v-flex xs12 class="setBgHeader widthfull" :style="{background: backgroudHeader}">
      <h3 class="centerDiv mt-1" style="color: white">แชทกับเรา</h3>
    </v-flex> -->
    <v-flex xs12 class="headername widthfull">
      <v-avatar class="f-l mr-2 user-photoprofilechat" >
        <img src="/static/img/logobiz.png" alt="John" class="alligator-turtle">
      </v-avatar>
      <v-layout row wrap align-center style="padding-top: 12px;">
          <h4 style="margin-left: 1vw;">คะแนนความพึงพอใจในการให้บริการ</h4>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="setHeightChatBoxrating" style="text-align: center;" v-if="stateSat == 'not_found'">
      <br>
      <h5>กรุณาให้คะแนนความพึงพอใจในการให้บริการ</h5>
      <br>
      <v-rating
        v-model="rating"
        background-color="grey darken-1"
        empty-icon="$vuetify.icons.ratingFull"
        color="yellow accent-4"
        :half-increments="halfincrements"
        :hover="hover"
        size="18"
        x-large
      ></v-rating>
      <br>
      <b style="font-size: 18px;">คะแนน : {{rating}} </b> 
      <br>
      <br>
        <v-btn  :style="{background: backgroudHeader}" :loading="loading" dark round @click="sendpoint()">ให้คะแนน</v-btn>
    </v-flex>
    <v-flex xs12 class="setHeightChatBoxrating" style="text-align: center;" v-else>
      <br>
      <h5>คุณได้ให้คะแนนความพึงพอใจในการให้บริการแล้ว</h5>
      <br>
      <v-rating
        v-model="stateSat"
        background-color="grey darken-1"
        empty-icon="$vuetify.icons.ratingFull"
        color="yellow accent-4"
        :half-increments="halfincrements"
        size="18"
        readonly
        x-large
      ></v-rating>
      <br>
      <b style="font-size: 18px;">คะแนน : {{stateSat}} </b> 
      <br>
      <br>
        <!-- <v-btn  :style="{background: backgroudHeader}" :loading="loading" dark round @click="sendpoint()">ให้คะแนน</v-btn> -->
    </v-flex>
  </v-layout>
</template>

<script>
import { sync } from 'vuex-pathify'
const theme = require('../assets/theme')
export default {
  data () {
    return {
      theme,
      backgroudHeader: '',
      loading: false,
      hover: true,
      halfincrements: true,
      rating: 0,
      subject: '',
      header: '',
      body: '',
      tokenuser: '',
      caseid: '',
      tokenservice: '',
      servicename: '',
      stateSat: ''
    }
  },
  created () {
    // this.subject = this.mysubject
    this.caseid = this.$route.params.caseid
    this.tokenuser = this.$route.params.tokenuser
    // this.tokenuser = this.mytokenuser
    this.servicename = this.$route.params.servicename
    this.getpoint()
    // this.concode = this.$route.params.concode
    // var servicename = this.$route.params.servicename
    if (this.theme[this.servicename].servicename === this.$route.params.servicename) {
      // console.log('in')
      this.tokenservice = 'Bearer ' + this.theme[this.servicename].authen
      this.backgroudHeader = this.theme[this.servicename].background
      // console.log(this.backgroudHeader)
    } else {
      this.tokenservice = 'Bearer ' + this.theme[this.servicename].authen
      this.backgroudHeader = '#01579b'
    }
  },
  computed: {
    ...sync('*')
  },
  watch: {
    // '$route.params.tokenroom' () {
    //   this.tokenroom = this.$route.params.tokenroom
    // }
  },
  methods: {
    getpoint () {
      this.axios.get(process.env.APIbackend + '/v1/oss-satisfaction?uid='+this.caseid).then((response) => {
        console.log(response.data)
        this.stateSat = response.data
        // if (response.data == 'not_found') {

        // } else {

        // }
        
      })
    },
    sendpoint () {
      // console.log(this.tokenroom)
      // console.log(this.tokenuser)
      // console.log(this.tokenservice)
      this.loading = true
      // this.header = {headers: {'Authorization': this.tokenservice}}
      this.body = {'uid': this.caseid, 'score': this.rating+'', 'token-user': this.tokenuser}
      this.axios.post(process.env.APIbackend + '/v1/oss-satisfaction', this.body, this.header).then((response) => {
        // console.log(response.data)
        if (response.data === 'success') {
          this.$swal({
            title: '<div style="font-size: 18px;">ให้คะแนนสำเร็จ</div>',
            text: 'ขอบคุณที่ใช้บริการค่ะ',
            type: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง'
          })
          // localStorage.setItem('score', this.rating)
          this.loading = false
          this.stateSat = this.rating+''
          // this.$router.push('/score/' + this.$route.params.servicename + '/' + this.$route.params.caseid)
          // this.$router.push({path: '/register', force: true})
        } else {
          // console.log('error')
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.headername {
  background-color: #424242;
  height: 50px;
  color: #E0E0E0;
  margin-top: -2px;
  /*margin-bottom: 1vh;*/
  /*position: fixed;*/
  /*width: 100%;*/
  /*margin-top:30px;*/
}

.setHeightChatBoxrating {
  height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);
  /*overflow-y: scroll;*/
  padding-top: 5px;
  background: white;
}
.setBgHeader {
  background-color: #01579B;
  height: 30px;
  border-top-left-radius: 10px; 
  border-top-right-radius: 10px;
}
.chatBoxFriend {
  word-wrap: break-word;
  max-width: 50%;
  border-radius: 25px;
  background: #E0E0E0;
  padding: 12px;
}
.chatBox {
  word-wrap: break-word;
  max-width: 50%;
  border-radius: 25px;
  background: #B3E5FC;
  color: black;
  padding: 12px;
}

textarea:focus{
  outline: none !important;
  box-sizing: border-box !important;
  resize: none;
}
.textBox{
  height: 50px;
  border-style: solid solid solid solid !important;
  border-width: 1px;
  border-radius: 7px;
  border-color: rgb(101,101,101);
}

.colorFooterMenu {
  color: #424242
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.user-photoprofilechat{
  background-color: white;
  width: 35px !important;
  height: 35px !important;
  border-radius: 50%;
  overflow: hidden;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Rating.vue